<template>
  <div>
    <div class="accordion-header collapsed">
      <button
        class="accordion-button"
        :class="{ collapsed: !isOpen }"
        :aria-expanded="isOpen"
        @click="toggleForm"
      >
        {{ $t('step1.familyMember') }}{{ memberIndex + 1 }}
      </button>
    </div>
    <div
      class="accordion-collapse collapse"
      :class="{ show: isOpen }"
      aria-labelledby="panelsStayOpen-headingOne"
    >
      <div class="accordion-body">
        <div :id="'additional-members-' + memberIndex">
          <div class="form-group border-start p-3 my-3 border-primary">
            <div>
              <div class="form-check form-check-inline">
                <FamilyMemberForm
                  :form="form"
                  :member-index="memberIndex"
                />
              </div>

              <div class="d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="removeFamilyMember"
                >
                  {{ $t('common.delete') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Helper Modal -->
    <AppModal
      :title="helperTitle"
      :content="helperContent"
      :is-open="openHelperModal"
      @onClose="openHelperModal = false"
    />
  </div>
</template>

<script>
import AppModal from '../shared/Modal.vue'
import FamilyMemberForm from './FamilyMemberForm.vue'

export default {
  name: 'AdditionalFamilyMember',
  components: {
    AppModal,
    FamilyMemberForm,
  },
  props: {
    memberIndex: { type: Number, required: true },
    policyHolderInsured: {
      type: Boolean,
      required: true,
    },
    isCollapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isPortugal: false,
      form: this.$formData.familyMembers[this.memberIndex].details,

      isOpen: this.isCollapse,
      helperModal: null,
      confirmDeleteFamilyModal: null,
      openHelperModal: false,
      helperTitle: '',
      helperContent: '',
    }
  },
  computed: {},
  watch: {
    isCollapse() {
      this.isOpen = this.$isCollapse
    },
  },
  mounted() {},
  methods: {
    toggleForm() {
      this.isOpen = !this.isOpen
    },
    removeFamilyMember() {
      this.$emit('onDelete', this.memberIndex)
    },
  },
}
</script>
